import type { DatasetRowsPage, RunPreviewRowsPage, TemplateRunStatus } from '@/types/templates';

export function normalizeDatasetRowsPagePayload(payload: Record<string, unknown>): DatasetRowsPage {
  const nextCursorRaw = payload.nextCursor ?? payload.next_cursor;
  const totalRowsRaw = payload.totalRows ?? payload.total_rows;
  const hasMoreRaw = payload.hasMore ?? payload.has_more;
  const accessModeRaw = payload.accessMode ?? payload.access_mode;
  const previewCapRaw = payload.previewCap ?? payload.preview_cap;
  const columnsRaw = payload.columns ?? payload.schema_columns;
  const columns = Array.isArray(columnsRaw)
    ? columnsRaw.filter((value): value is string => typeof value === 'string' && value.trim().length > 0)
    : undefined;

  return {
    rows: Array.isArray(payload.rows) ? (payload.rows as DatasetRowsPage['rows']) : [],
    columns: columns && columns.length > 0 ? columns : undefined,
    nextCursor: typeof nextCursorRaw === 'string' ? nextCursorRaw : null,
    hasMore: typeof hasMoreRaw === 'boolean' ? hasMoreRaw : typeof nextCursorRaw === 'string' && nextCursorRaw.length > 0,
    totalRows: typeof totalRowsRaw === 'number' ? totalRowsRaw : null,
    accessMode: accessModeRaw === 'preview' || accessModeRaw === 'full' ? accessModeRaw : undefined,
    previewCap: typeof previewCapRaw === 'number' ? previewCapRaw : null,
  };
}

export function normalizeRunPreviewRowsPagePayload(payload: Record<string, unknown>): RunPreviewRowsPage {
  const nextCursorRaw = payload.nextCursor ?? payload.next_cursor;
  const totalRowsRaw = payload.totalRows ?? payload.total_rows;
  const hasMoreRaw = payload.hasMore ?? payload.has_more;
  const columnsRaw = payload.columns ?? payload.schema_columns;
  const runIdRaw = payload.runId ?? payload.run_id;
  const datasetIdRaw = payload.datasetId ?? payload.dataset_id;
  const sourceRaw = payload.source;
  const finalRaw = payload.final;
  const statusRaw = payload.status;
  const columns = Array.isArray(columnsRaw)
    ? columnsRaw.filter((value): value is string => typeof value === 'string' && value.trim().length > 0)
    : undefined;

  return {
    runId: typeof runIdRaw === 'string' ? runIdRaw : '',
    datasetId: typeof datasetIdRaw === 'string' ? datasetIdRaw : null,
    status: typeof statusRaw === 'string' ? (statusRaw as TemplateRunStatus) : undefined,
    rows: Array.isArray(payload.rows) ? (payload.rows as RunPreviewRowsPage['rows']) : [],
    columns: columns && columns.length > 0 ? columns : undefined,
    nextCursor: typeof nextCursorRaw === 'string' ? nextCursorRaw : null,
    hasMore: typeof hasMoreRaw === 'boolean' ? hasMoreRaw : typeof nextCursorRaw === 'string' && nextCursorRaw.length > 0,
    totalRows: typeof totalRowsRaw === 'number' ? totalRowsRaw : null,
    source: sourceRaw === 'run_accumulator' ? sourceRaw : 'run_accumulator',
    final: finalRaw === false ? finalRaw : false,
  };
}
